<template>
  <svg version="1.1" id="Everyone" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
   viewBox="0 0 389.4 527" style="enable-background:new 0 0 389.4 527;" xml:space="preserve">
<path class="st0" d="M383.8,521.4H5.7V5.7h378.1V521.4L383.8,521.4z M389.4,0h-5.7H5.7H0v5.7v515.7v5.7h5.7h378.1h5.7v-5.7V5.7V0z"
  />
<g>
  <path class="st0" d="M27.2,496.7v-46.1H95v10.8H54.4v6.6h34.3v10.8H54.4v7.2h42.1v10.8H27.2L27.2,496.7z"/>
  <path class="st0" d="M154.2,464c-0.4-1.6-2-2.6-3.9-3.1c-1.9-0.6-4.3-0.8-7-0.8c-6,0-8.7,1-8.7,2.7c0,6.8,47.8,2.6,47.8,19.3
    c0,10.7-16.1,15.9-38.9,15.9c-21.9,0-36.3-7.1-36.8-15.5h26.1c0.6,1.7,2.2,2.9,4.5,3.6c2.2,0.8,5,1.2,7.7,1.2
    c6.8,0,11.3-1.2,11.3-3.4c0-7-47.8-2.2-47.8-19.8c0-9.8,15.3-14.7,36-14.7c23.1,0,33.6,6.5,35.6,14.6H154.2L154.2,464z"/>
  <path class="st0" d="M223.1,470.6h10.7c8.5,0,13-1.2,13-4.4c0-3.3-4.6-4.8-11-4.8h-12.7L223.1,470.6L223.1,470.6z M223.1,480.7
    v16.1h-27.2v-46.1h39.3c27.7,0,36.8,4.2,36.8,13.2c0,5.3-4.2,9.8-13.9,11.3c8.8,1.8,14.1,2.9,14.1,12.2c0,6-0.4,8.1,2.9,8.1v1.4
    h-27.6c-0.7-1-1.4-4-1.4-8.1c0-6.1-1.9-8-14.6-8H223.1z"/>
  <path class="st0" d="M315.9,461.4v7.7h11.4c5.4,0,9.4-1.4,9.4-4c0-3.6-5.4-3.7-11.1-3.7H315.9z M315.9,477.5v8.5h11.9
    c6.7,0,11.8-0.8,11.8-4.2c0-4-6.3-4.3-15-4.3L315.9,477.5L315.9,477.5z M288.7,496.7v-46.1h39.7c18.7,0,33.6,2.5,33.6,11.6
    c0,4.8-5.5,8.2-10.8,10c9,1.3,13.8,5.6,13.8,10.6c0,10.3-14.2,13.9-35.8,13.9H288.7L288.7,496.7z"/>
</g>
<g>
  <path class="st0" d="M165.9,46.9h-5v14.8v0h5c1.1,0,2-0.2,2.7-0.8c0.7-0.5,1.3-1.1,1.8-1.9c0.4-0.8,0.8-1.6,0.9-2.5
    c0.2-0.9,0.3-1.8,0.3-2.6c0-2.6-0.5-4.4-1.5-5.4C169,47.4,167.7,46.9,165.9,46.9z"/>
  <path class="st0" d="M255,50.5c-0.5-1.6-1.2-2.7-2.1-3.5c-1-0.8-2.2-1.1-3.8-1.1c-1.6,0-2.9,0.4-3.8,1.1c-1,0.8-1.7,1.9-2.2,3.5
    c-0.5,1.6-0.8,3.6-1,6.1c-0.1,2.5-0.2,5.4-0.2,8.8s0.1,6.3,0.2,8.8c0.2,2.5,0.5,4.5,1,6.1c0.5,1.6,1.2,2.7,2.2,3.5
    c0.9,0.8,2.2,1.1,3.8,1.1c1.5,0,2.8-0.4,3.8-1.1c0.9-0.8,1.7-1.9,2.1-3.5c0.5-1.6,0.8-3.6,1-6.1c0.2-2.5,0.2-5.4,0.2-8.8
    s-0.1-6.3-0.2-8.8C255.8,54,255.5,52,255,50.5z"/>
  <path class="st0" d="M26.2,24.9v78.7h337.2V24.9H26.2z M64.5,91.9H34.7v0V38.8h29.2v8.2h-18V60h16.6v8.2H45.9v15.5h18.6V91.9z
     M93.7,91.9H80.6L67.5,38.8h0h0h11.6l8.3,38.6h0.1l9.3-38.6h11.1L93.7,91.9z M142.7,91.9h-29.8l0,0V38.8h29.2v8.2h-18V60h16.6v8.2
    h-16.6v15.5h18.6V91.9z M173,91.9c-0.7-1.6-1.1-3.3-1.1-5.1c0-1.7,0-3.5,0-5.2c0-1.6,0-3.1-0.1-4.5c0-1.4-0.3-2.7-0.7-3.7
    s-1.3-1.9-2.4-2.5c-1.1-0.6-2.7-1-4.9-1h-2.9v22h0h-11.2V38.8h20.7c3.9,0,6.9,1.2,9.2,3.5c2.2,2.4,3.4,5.8,3.4,10.4
    c0,3.4-0.8,6.2-2.3,8.6c-1.5,2.4-4.1,3.8-7.7,4.4v0.1c0.6,0.1,1.4,0.2,2.5,0.4c1.1,0.2,2.2,0.6,3.2,1.3c1.1,0.7,2,1.7,2.8,3.1
    c0.8,1.3,1.2,3.2,1.2,5.6c0,0.8,0,2,0,3.5c0,1.5,0.1,3.1,0.2,4.7c0.1,1.6,0.2,3.1,0.4,4.5c0.2,1.4,0.4,2.3,0.7,2.9H173z M211,73.5
    v18.4h-11.2V73.5l-14-34.7h12.2l8,22.4l8.5-22.4H226L211,73.5z M267.2,75.5c-0.2,3.3-0.9,6.2-2,8.8c-1.1,2.6-3,4.6-5.5,6.2
    s-6.1,2.3-10.7,2.3c-4.6,0-8.2-0.8-10.7-2.3c-2.5-1.5-4.3-3.6-5.5-6.2c-1.1-2.6-1.8-5.5-2-8.8c-0.2-3.3-0.3-6.7-0.3-10.2
    c0-3.5,0.1-6.9,0.3-10.2c0.2-3.3,0.9-6.2,2-8.8c1.1-2.6,3-4.6,5.5-6.1c2.5-1.5,6.1-2.3,10.7-2.3c4.6,0,8.1,0.8,10.7,2.3
    c2.5,1.5,4.3,3.6,5.5,6.1c1.1,2.6,1.8,5.5,2,8.8c0.2,3.3,0.3,6.7,0.3,10.2C267.5,68.8,267.4,72.2,267.2,75.5z M316.4,91.9h-14.7
    L287.1,53h-0.1v38.8h-10.4V38.8h15.1l14.2,36.8h0.2V38.8h10.4V91.9z M355.6,91.9h-29.8l0,0V38.8H355v8.2h-18V60h16.6v8.2H337v15.5
    h18.6V91.9z"/>
</g>
<g>
  <polygon class="st1" points="309.1,301.6 210.3,331.1 202.1,305.1 290.4,278.8 271.3,218.4 182.9,244.7 175.1,220 270.8,191.6 
    251.6,131.2 60.6,188.1 60.6,188.1 134.2,419.8 328.3,361.9   "/>
  <path class="st0" d="M335.1,388.4c-8.4,0-15.2,6.3-15.2,14.1c0,7.8,6.8,14.2,15.2,14.2c8.4,0,15.1-6.4,15.1-14.2
    C350.2,394.7,343.5,388.4,335.1,388.4z M339.1,412.3c-0.2-1.1-0.6-2.5-0.7-3.6c-0.2-1.7-0.2-3.4-1.2-4.3c-0.9-0.7-2-0.7-3.2-0.7
    h-2.8l0,0v8.6h-3.4v-20.2h7c4,0,8,1,8,5.6c0,2.3-1.4,4.2-4.4,4.7v0.1c3,0.5,3.3,1.8,3.7,4c0.3,1.9,0.5,4,1.2,5.8H339.1z"/>
  <path class="st0" d="M26.8,123v306.7h336.6V123H26.8z M60.6,188.1L60.6,188.1l191.1-56.9l19.1,60.3L175.1,220l7.8,24.7l88.4-26.3
    l19.1,60.4l-88.4,26.3l8.2,26l98.8-29.5l19.2,60.3l-194.2,57.9L60.6,188.1z M335.1,419.6c-10.3,0-18.5-7.7-18.5-17.2
    c0-9.4,8.2-17.1,18.5-17.1c10.2,0,18.4,7.7,18.4,17.1C353.5,411.9,345.3,419.6,335.1,419.6z"/>
  <path class="st0" d="M335.2,395.3h-4v5.2h3.6c3.2-0.1,3.9-1.4,3.9-2.8C338.7,396.1,337.9,395.3,335.2,395.3z"/>
</g>
</svg>
</template>
<script>
  export default {
    name: 'Everyone',
    replace: true,
    data () {
      return {}
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/Everyone.vue